import React from "react";
import RecruitmentListPage from "../../recruitment-shared/pages/RecruitmentListPage";

export default function NonFacultyRecruitmentsList() {
  return <RecruitmentListPage type="NON_FACULTY" />;
}